<div class="ai-chat-card">
  <div class="ai-chat__messages">
    <div
      class="ai-chat__bubble"
      *ngFor="let message of messages()"
      [class.ai-chat__bubble--ai]="message.role === 'ai'"
      [class.ai-chat__bubble--user]="message.role === 'user'"
    >
      {{ message.text }}
    </div>

    <div class="ai-chat__typing" *ngIf="loading()">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="ai-chat__feedback ai-chat__feedback--error" *ngIf="error()">
      {{ error() }}
    </div>

    <div
      class="ai-chat__feedback ai-chat__feedback--error"
      *ngIf="bookingError()"
    >
      {{ bookingError() }}
    </div>

    <div
      class="ai-chat__feedback ai-chat__feedback--success"
      *ngIf="successMessage()"
    >
      {{ successMessage() }}
    </div>

    <div class="ai-chat__recommendations" *ngIf="result() as res">
      <article
        class="ai-chat__result"
        *ngFor="let rec of res.recommendations; trackBy: trackBySalon"
      >
        <h4>{{ rec.salon_name }}</h4>

        <p>
          {{ rec.staff_name }} · {{ rec.total_duration_minutes }} mins · ${{
            rec.total_price
          }}
        </p>

        <div class="ai-chat__slots" *ngIf="rec.slot_options?.length">
          <button
            type="button"
            *ngFor="let slot of rec.slot_options"
            (click)="chooseSlot(rec, slot.slot_start, slot.slot_end)"
            [disabled]="booking()"
          >
            {{ slot.slot_start | date: "EEE, MMM d, h:mm a" }}
          </button>
        </div>

        <button
          type="button"
          class="ai-chat__book"
          *ngIf="!rec.slot_options?.length && rec.slot_start"
          (click)="bookRecommendation(rec)"
          [disabled]="booking()"
        >
          Book {{ rec.slot_start | date: "EEE, MMM d, h:mm a" }}
        </button>
      </article>
    </div>
  </div>

  <div class="ai-chat__quick">
    <button
      type="button"
      *ngFor="let item of quickPrompts"
      (click)="usePrompt(item)"
    >
      {{ item }}
    </button>
  </div>

  <div class="ai-chat__composer">
    <textarea
      [(ngModel)]="prompt"
      rows="1"
      placeholder="Message AI..."
      (keydown.enter)="submit(); $event.preventDefault()"
    ></textarea>

    <button
      type="button"
      [disabled]="loading() || !prompt.trim()"
      (click)="submit()"
    >
      Ask
    </button>
  </div>
</div>
